import React, { memo, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { CopilotContext, CopilotComment as Comment, useTypewriterEffect } from '@Sage/ssm-web5';
import { Button } from '@Sage/hoi-poi-ui';
import sanitizeHtml from 'sanitize-html';
import metadata from 'lib/metadata';
import { getLiteral } from 'utils/getLiteral';

import './styles.scss';

const EmptySummary = ({ onRefreshGoldenMinute, literals }) => {
    const isFirstRender = useRef(true);
    const chatBoxRef = useRef(null);
    const { goldenMinuteCtaViews: ctaViews, updateGoldenMinuteCtaViews: updateCTAViews } =
        useContext(CopilotContext);

    const placeholderText = useMemo(
        () => sanitizeHtml(literals?.emptySummary),
        [literals?.emptySummary],
    );

    // Animate only on first view (ctaViews === 0); afterwards show text instantly
    const [shouldAnimate, setShouldAnimate] = useState(false);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            if (ctaViews === 0) {
                updateCTAViews();
                setShouldAnimate(true);
            }
        }
    }, [ctaViews, updateCTAViews]);

    const text = useTypewriterEffect({
        text: shouldAnimate ? placeholderText || '' : '',
        finished: true,
        enabled: shouldAnimate,
    });

    // When not animating (subsequent views), show the full text directly
    const displayText = shouldAnimate ? text : placeholderText || '';

    const getChatBoxRef = useCallback(({ ref }) => {
        if (!ref) return;
        chatBoxRef.current = ref;
    }, []);

    return (
        <div className="copilot-golden-minute-empty">
            <div className="copilot-golden-minute-empty__text">
                <Comment
                    text={displayText}
                    avatar={metadata.SageCopilotIcon}
                    getChatBoxRef={getChatBoxRef}
                    onClick={onRefreshGoldenMinute}
                    isWidget
                />
            </div>
            <div className="copilot-golden-minute-empty__button">
                <Button type="promotion" size="big" onClick={onRefreshGoldenMinute}>
                    {literals?.emptySummaryCTA}
                </Button>
            </div>
        </div>
    );
};

export default memo(EmptySummary);
